import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import { Typography, Popover } from "@mui/material";
import InstaColors, {
  DeleteButton,
  fontFamily,
  paddingAndMargin,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
  screenHeaderStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";
import { ConditionalPagination } from "../../utils/paginationUtils";
import { businessunitName } from "../../App_Settings/app_settings";
import { useHistory } from "react-router-dom";
import SearchInput from "../Constants/search_input";
import { handleFileDelete } from "../../services/deleteService";
import { updateFileData } from "../../services/fileDataService";
import DeleteModal from "../Models/Delete/DeleteModal";
import CircularProgress from "@mui/material/CircularProgress";
import { formatDate, getAllFilesList } from "../../Utility/utility";
import Loader from "../../Utility/loading";
import "../App.css";
import "../../App.css";

//
export default function RejectionsFunction() {
  const { isMenuOpen } = useSharedValue();
  const { drawerwidth, updateDrawerWidth } = useSharedValue();
  // const { searchValue } = useSharedValue();
  const [searchValue, setSearchValue] = useState("");
  const [extractedData, setExtractedData] = useState(null);
  const { extractLimit } = useSharedValue();

  const { defaultBusinessunit, defaultOrganization, defaultUser } = useSharedValue();
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const history = useHistory();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isReturningToQueue, setIsReturningToQueue] = useState(false);

  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();
  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [endIndex, setEndIndex] = useState(10);

  const columns = [
    { field: "fileName", headerName: "FILE NAME", type: "string" },
    // { field: 'entityUniqueIdentifier', headerName: 'UID', type: 'string', },
    { field: "businessUnit", headerName: businessunitName, type: "string" },
    { field: "rejectedBy", headerName: "REJECTED BY", type: "string" },
    { field: "rejectedDate", headerName: "REJECTED DATE", type: "string" },
    { field: "rejectionReason", headerName: "REASON", type: "string" },
    { field: "review", headerName: "REVIEW", type: "string" },
    { field: "notes", headerName: "NOTE", type: "string" },
    { field: "returnToQueue", headerName: "RETURN TO QUEUE", type: "string" },
    { field: "functions", headerName: "", type: "string" },
  ];
  const { handleUserTraiLimit } = useSharedValue();
  const [rows, setRows] = React.useState([]);
  const [popoverAnchorEl, setPopoverAnchorEl] = React.useState(null);
  const [notes, setNotes] = useState(null);

  const handleClose = () => {
    setPopoverAnchorEl(null);
  };

  const open = Boolean(popoverAnchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleSaveClick = async () => {
    if (selectedFiles.length === 0) {
      alert("Please select files to return to processing queue.");
      return;
    }

    setIsReturningToQueue(true);

    try {
      const updatePromises = selectedFiles.map(async (fileId) => {
        const row = rows.find((r) => r.fileImportId === fileId);
        if (!row) return;

        const updatedRowData = {
          ...row,
          isProcessed: false,
          status: null,
          reviewedDate: null,
          rejectionReason: null,
          rejectedBy: null,
          rejectedDate: null,
          notes: null,
        };

        await updateFileData(updatedRowData);
        return fileId;
      });

      await Promise.all(updatePromises);

      // Remove successfully processed files from the view
      setRows((prevRows) => prevRows.filter((row) => !selectedFiles.includes(row.fileImportId)));
      setSelectedFiles([]);

      alert(`${selectedFiles.length} file(s) returned to processing queue successfully!`);
    } catch (error) {
      console.error("Error returning files to queue:", error);
      alert("Failed to return some files to processing queue. Please try again.");
    } finally {
      setIsReturningToQueue(false);
    }
  };

  useEffect(() => {
    // setLoading(true);

    handleUserTraiLimit();

    getAllFiles();
  }, [searchValue, defaultBusinessunit, defaultOrganization, defaultUser]);
  const getAllFiles = async () => {
    setLoading(true);
    const data = await getAllFilesList(
      history,
      defaultOrganization,
      defaultBusinessunit,
      defaultUser
    );

    setRows(
      data.filter(
        (row) =>
          row.rejectedBy !== null && row.fileName.toLowerCase().includes(searchValue.toLowerCase())
      )
    );
    setLoading(false);
  };

  React.useEffect(() => {
    const items = JSON.parse(localStorage.getItem("ExtractedData"));
    if (items) {
      setExtractedData(items);
    }
  }, []);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setStartIndex((parseInt(newPage) - 1) * numberOfSelectedRows);
    setEndIndex((parseInt(newPage) - 1) * numberOfSelectedRows + numberOfSelectedRows);
    // Clear selections when changing pages
    setSelectedFiles([]);
  };

  let totalPages = Math.ceil(
    rows.filter((item) => item.rejectedBy !== null).length / numberOfSelectedRows
  );

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value);
    // updateRowNumberOfPages(newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setStartIndex(0);
    setCurrentPage(1);
    setEndIndex(newRowsPerPage);
    // Clear selections when changing page size
    setSelectedFiles([]);
  };

  const handleReviewClick = (id, rowItem) => {
    history.push({
      pathname: "/displayExtractionView",
      state: {
        someValue: id,
        accuracyPercentage: rowItem.accuracyPercentage,
        datatable: rowItem.dataExtraction,
        dataTree: rowItem.dataVisualisation,
        row: rowItem,
        rootValue: "/rejections",
        iSEdit: true,
      },
    });
  };

  const handleReturnToQueue = async (row) => {
    setIsReturningToQueue(true);

    try {
      const updatedRowData = {
        ...row,
        isProcessed: false,
        status: null,
        reviewedDate: null,
        rejectionReason: null,
        rejectedBy: null,
        rejectedDate: null,
        notes: null,
      };

      await updateFileData(updatedRowData);

      // Remove the file from the current view since it's no longer rejected
      setRows((prevRows) => prevRows.filter((r) => r.fileImportId !== row.fileImportId));
      alert("File returned to processing queue successfully!");
    } catch (error) {
      console.error("Error returning file to queue:", error);
      alert("Failed to return file to processing queue. Please try again.");
    } finally {
      setIsReturningToQueue(false);
    }
  };

  const handleSelection = (isChecked, fileImportId) => {
    if (isChecked) {
      setSelectedFiles((prev) => [...prev, fileImportId]);
    } else {
      setSelectedFiles((prev) => prev.filter((id) => id !== fileImportId));
    }
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const visibleFiles = rows
        .filter((item) => item.rejectedBy !== null)
        .sort((a, b) => new Date(b.rejectedDate) - new Date(a.rejectedDate)) // Sort by rejectedDate descending (latest first)
        .slice(startIndex, endIndex)
        .map((row) => row.fileImportId);
      setSelectedFiles(visibleFiles);
    } else {
      setSelectedFiles([]);
    }
  };

  // Use centralized delete service
  const handleDelete = async () => {
    if (!selectDeletedItem) {
      alert("No file selected for deletion.");
      return;
    }

    const rowToDelete = rows.find((row) => row.fileImportId === selectDeletedItem);

    await handleFileDelete({
      fileImportId: selectDeletedItem,
      fileName: rowToDelete?.fileName || "Unknown file",
      rows,
      setIsDeleting,
      getAllFiles,

      setIsPopupOpen,
    });
  };

  return (
    <div style={screenHeaderStyle(isMenuOpen)}>
      {/* Loading overlay during deletion */}
      {(isDeleting || isReturningToQueue) && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            zIndex: 999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CircularProgress size={24} style={{ color: "#2aa7e0" }} />
            <span style={{ fontFamily: fontFamily, fontSize: "14px" }}>
              {isDeleting ? "Deleting file..." : "Returning files to processing queue..."}
            </span>
          </div>
        </div>
      )}

      {/* The div that fills the remaining height */}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginBottom: paddingAndMargin.headerBelowHeight,
          marginTop: paddingAndMargin.headerTopHeight,
          marginRight: 30,
          marginLeft: 30,
        }}
      >
        <SearchInput
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          onClick={() => {
            setSearchValue("");
          }}
        />

        {/* Rows per page dropdown - next to search box */}
        {rows.filter((item) => item.rejectedBy !== null).length > numberOfSelectedRows && (
          <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
            <label
              style={{
                fontFamily: fontFamily,
                fontWeight: 400,
                fontSize: 12,
                color: "#333",
              }}
            >
              Displayed per page:&nbsp;
              <select
                className="pagination-select"
                style={{ width: 50 }}
                value={numberOfSelectedRows}
                onChange={handleRowsPerPageChange}
              >
                {[5, 10, 15, 20, 25, 30].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )}

        <div style={{ marginLeft: "auto" }}>
          {/* Adjusting button styles as per requirements */}
          {/* <Button variant="contained" style={reviewScreenButtonWithOutColor(80)} onClick={handleDeleteList}>Delete</Button> */}
          <Button
            variant="contained"
            style={reviewScreenButtonWithColor(240)}
            onClick={handleSaveClick}
            disabled={isReturningToQueue}
          >
            {isReturningToQueue ? "Processing..." : "Return To Processing Queue"}
          </Button>
        </div>
      </div>

      {/* Displaying columns */}
      <div class="columntitlesRowStyle">
        <div>
          <Checkbox
            onChange={(e) => handleSelectAll(e.target.checked)}
            size="small"
            style={{ color: InstaColors.white }}
            checked={
              selectedFiles.length > 0 &&
              selectedFiles.length ===
                rows
                  .filter((item) => item.rejectedBy !== null)
                  .sort((a, b) => new Date(b.rejectedDate) - new Date(a.rejectedDate))
                  .slice(startIndex, endIndex).length
            }
            indeterminate={
              selectedFiles.length > 0 &&
              selectedFiles.length <
                rows
                  .filter((item) => item.rejectedBy !== null)
                  .sort((a, b) => new Date(b.rejectedDate) - new Date(a.rejectedDate))
                  .slice(startIndex, endIndex).length
            }
          />
        </div>
        {columns.map((column) => (
          <div key={column.field} className="columntitlesStyle">
            <UpperLowerText text={column.headerName} />
          </div>
        ))}
      </div>
      {loading ? (
        <>
          {/* <CircularProgress /> */}
          <Loader />
        </>
      ) : rows.length === 0 ? (
        <div className="no-record">There are no records available.</div>
      ) : (
        <div>
          {rows
            .filter((item) => item.rejectedBy !== null)
            .sort((a, b) => new Date(b.rejectedDate) - new Date(a.rejectedDate)) // Sort by rejectedDate descending (latest first)
            .slice(startIndex, endIndex)
            .map((row, indexValue) => (
              <div key={row.fileImportId} class="columnRowStyle">
                <div>
                  <Checkbox
                    size="small"
                    title="Select"
                    onChange={(event) => handleSelection(event.target.checked, row.fileImportId)}
                    style={{ color: "#2aa7e0", marginBottom: 3 }}
                    checked={selectedFiles.includes(row.fileImportId)}
                  />
                </div>
                {columns.map((column) => (
                  <div
                    key={column.field}
                    title={
                      column.headerName === "REJECTED DATE"
                        ? formatDate(row[column.field])
                        : row[column.field]
                    }
                    class="columnValuesStyle"
                    // style={columnValuesStyle}
                  >
                    {column.field === "review" && (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleReviewClick(row.fileImportId, row)}
                      >
                        <span
                          style={{
                            fontFamily: fontFamily, // Add this line
                            fontWeight: 300,
                            fontSize: 14,
                            color: InstaColors.primary,
                            textOverflow: "ellipsis",
                            marginLeft: 2,
                            textTransform: "none",
                            // marginRight: 10
                          }}
                        >
                          Review
                        </span>
                      </div>
                    )}

                    {column.field === "returnToQueue" && (
                      <div style={{ cursor: "pointer" }} onClick={() => handleReturnToQueue(row)}>
                        <span
                          style={{
                            fontFamily: fontFamily,
                            fontWeight: 300,
                            fontSize: 14,
                            color: InstaColors.primary,
                            textOverflow: "ellipsis",
                            marginLeft: 2,
                            textTransform: "none",
                          }}
                        >
                          Return
                        </span>
                      </div>
                    )}

                    {column.field === "notes" ? (
                      <div>
                        <img
                          title="Rejection Reason"
                          onClick={(event) => {
                            setNotes(row.notes);
                            setPopoverAnchorEl(event.currentTarget);
                          }}
                          src="/EditFile(Blue).png"
                          alt="Edit"
                          style={{ width: 18, height: 18, cursor: "pointer" }}
                        />
                        <Popover
                          id={id}
                          open={open}
                          anchorEl={popoverAnchorEl}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                        >
                          <Typography>
                            <div style={{ width: 250, alignContent: "center", padding: 10 }}>
                              {notes}
                            </div>
                          </Typography>
                          {/* Place your menu items or content here */}
                        </Popover>
                      </div>
                    ) : column.field === "functions" ? (
                      <div style={{ display: "flex", alignItems: "flex-end" }}>
                        <div style={{ marginRight: "auto" }}></div>
                        <DeleteButton
                          onClick={() => {
                            if (extractLimit === null || extractLimit === undefined) {
                              setIsPopupOpen(true);
                              setSelectDeletedItem(row.fileImportId);
                            } else {
                              alert(
                                "You do not have permission to access this feature in your trial version."
                              );
                            }
                          }}
                        />
                      </div>
                    ) : column.headerName === "REJECTED DATE" ? (
                      formatDate(row[column.field])
                    ) : (
                      row[column.field]
                    )}
                  </div>
                ))}
              </div>
            ))}
        </div>
      )}

      <DeleteModal
        open={isPopupOpen}
        isDeleting={isDeleting}
        onClose={() => setIsPopupOpen(false)}
        onDelete={handleDelete}
        deleteButtonStyle={reviewScreenButtonWithColor(100)}
        cancelButtonStyle={reviewScreenButtonWithOutColor(100)}
      />
      <ConditionalPagination
        itemCount={rows.filter((item) => item.rejectedBy !== null).length}
        itemsPerPage={numberOfSelectedRows}
        threshold={numberOfSelectedRows}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: { marginLeft: "auto", marginRight: 10, marginTop: "auto", marginBottom: 10 },
        }}
      />
    </div>
  );
}
